import { Card, Grid, InputAdornment, Menu, MenuItem, Typography, useMediaQuery, LinearProgress } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { TraxxButton, TraxxInput } from 'app/components';
import VisibilityAdornment from 'app/components/TraxxInput/components';
import clsx from 'clsx';
import React, { useState, useEffect, useRef } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import { useToastCatcher } from 'app/utils';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import { useAsyncTask } from 'app/utils';
import { API } from 'app/services';

const useStyles = makeStyles(({ breakpoints }) => ({
  adornment: {
    marginTop: 4,

    [breakpoints.up('md')]: {
      marginTop: 2,
    },
  },
  card: {
    marginTop: 20,

    [breakpoints.up('md')]: {
      marginLeft: 59,
      marginTop: 0,
    },
  },
  container: {
    height: 326,
    width: 330,

    [breakpoints.up('md')]: {
      height: 598,
      width: 410,
    },
  },
  error: { marginTop: 4 },
  form: {
    alignContent: 'center',
    display: 'flex',
    flexDirection: 'column',
    height: 575,
    justifyContent: 'space-between',
    padding: 35,
    width: 350,

    [breakpoints.up('md')]: {
      height: 598,
      padding: 40,
      width: 410,
    },
  },
  image: {
    height: 250,
    width: 250,

    [breakpoints.up('md')]: {
      height: 411,
      width: 411,
    },
  },
  pointer: { cursor: 'pointer' },
}));

function SignUpView(props) {
  const classes = useStyles();

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const inviteToken = queryParams.get('invite');
  const [invitation, setInvitation] = useState();
  const [runLoadInvite, loadingInvite, errorInvite] = useAsyncTask('loadInvite');

  const { inputs, setInputs, errors, onSignup, recaptcha } = props;

  const matches = useMediaQuery(({ breakpoints }) => breakpoints.up('md'));

  const [anchorElement, setAnchorElement] = useState(null);
  const [visibility, setVisibility] = useState(false);
  const [isVerified, setIsVerified] = useState(false);
  const loading = useSelector((state) => state.layout.loadingTasks);

  useEffect(() => {
    if (isVerified) {

      onSignup();
      recaptcha.current.reset();
      setIsVerified(false);
    }
    if (!inviteToken) return;
    runLoadInvite(async () => {
      recaptcha.current.reset();
      const result = await API.Auth.load_invite(inviteToken);
      setInvitation(result.model);
      setInputs((values) => ({
        ...values,
        inviteToken,
      }));
    });

    // eslint-disable-next-line
  }, [inviteToken, isVerified]);

  const handleChange =
    (type) =>
    ({ target }) =>
      setInputs((values) => ({
        ...values,
        [type]: target.value,
      }));

  const handleDropDown = ({ currentTarget }) => setAnchorElement((value) => (value ? null : currentTarget));

  const handleSelect = ({ target }) => {
    setInputs((values) => ({
      ...values,
      countryCode: target.value,
    }));
    setAnchorElement(null);
  };

  const handleVisibility = () => setVisibility((value) => !value);

  const recaptchaKey = process.env.REACT_APP_RECAPTCHA_KEY;

  const inputProps = [
    {
      id: 'SignUp-name',
      autoComplete: 'name',
      error: errors.name,
      label: 'Name',
      onChange: handleChange('name'),
      placeholder: 'Full name',
      value: inputs.name,
    },
    {
      id: 'SignUp-email',
      autoComplete: 'email',
      error: errors.email,
      label: 'Email address',
      onChange: handleChange('email'),
      placeholder: 'example@email.com',
      value: inputs.email,
    },
    {
      id: 'SignUp-password',
      autoComplete: 'password',
      error: errors.password,
      InputProps: {
        endAdornment: <VisibilityAdornment onClick={handleVisibility} />,
      },
      label: 'Password',
      onChange: handleChange('password'),
      placeholder: 'Minimum 8 characters',
      type: visibility ? 'text' : 'password',
      value: inputs.password,
    },
    {
      id: 'SignUp-phoneNumber',
      autoComplete: 'ph-number',
      error: errors.phoneNumber,
      InputProps: {
        endAdornment: (
          <InputAdornment className={clsx(classes.adornment, classes.pointer)} onClick={handleDropDown} position="start">
            <img src="/images/arrow_drop_down.svg" alt="arrow-drop-down-icon" />
          </InputAdornment>
        ),
        startAdornment: (
          <InputAdornment className={classes.adornment} position="start">
            &#43;{inputs.countryCode}
          </InputAdornment>
        ),
      },
      label: 'Phone number',
      onChange: handleChange('phoneNumber'),
      placeholder: '1234578',
      value: inputs.phoneNumber,
      onKeyPress: (ev) => {
        if (ev.key === 'Enter') onSignup(ev);
      },
    },
  ];

  if (!invitation) {
    inputProps.unshift({
      id: 'SignUp-company',
      autoComplete: 'company',
      error: errors.company,
      label: 'Company Name',
      onChange: handleChange('company'),
      placeholder: 'ABC PTE LTD',
      value: inputs.company,
    });
  }

  const errorParser = (error) => {
    let message = 'Error occurred!';
    if (error.message === 'access_handle conflict') message = 'Email exist';
    return message;
  };
  const [toaster, errorCatcher] = useToastCatcher({ errorParser, taskname: 'signup' });
  const onReCAPTCHAChange = async (token) => {
    if (token) {
      const websiteID = process.env.VITE_WEBSITE_ID;
      errorCatcher(async () => {
        await API.Auth.recaptcha({
          token,
          websiteID,
        });
        // setEmail(email);
      }, 'signup');
      setIsVerified(true);

      // const response = await fetch('http://localhost:8181/api/mapp/donationportal/recaptcha', {
      //   method: 'POST',
      //   body: JSON.stringify({ token, websiteID }),
      //   headers: {
      //     Authorization: Date.now(),
      //     'Content-Type': 'application/json',
      //   },
      // });
      // const data = await response.json();
      // if (data.result.success) {
      //   setIsVerified(true);
      // }
    }
  };

  return (
    <>
      <Grid className={classes.container} container alignContent={matches ? 'space-around' : 'space-between'} justify="center">
        <Typography variant={matches ? 'h4' : 'h5'}>Sign up for a free account&#46;</Typography>

        <img className={classes.image} src="/images/compliance.svg" alt="compliance_logo" />
      </Grid>

      <Card className={classes.card}>
        <form className={classes.form} autoComplete="false">
          <ReCAPTCHA ref={recaptcha} sitekey={recaptchaKey} size="invisible" onChange={onReCAPTCHAChange} />
          <Typography variant="h5">Create your free account</Typography>

          <LinearProgress hidden={!loadingInvite} />

          {!!invitation && (
            <Typography variant="body1">
              You are invited to join {invitation.account || 'an account'} by {invitation.inviter || 'someone'}.
            </Typography>
          )}

          {!!errorInvite && (
            <Typography variant="body1" color="error">
              {errorInvite.message}
            </Typography>
          )}

          {inputProps.map((props) => (
            <TraxxInput key={props.id} {...props} />
          ))}

          <Menu anchorEl={anchorElement} keepMounted open={!!anchorElement} onClose={handleDropDown}>
            <MenuItem onClick={handleSelect} value="+65">
              &#43;65
            </MenuItem>
            <MenuItem onClick={handleSelect} value="+60">
              &#43;60
            </MenuItem>
            <MenuItem onClick={handleSelect} value="+86">
              &#43;86
            </MenuItem>
          </Menu>

          <TraxxButton
            loading={loading['signup']}
            onSubmit={() => {
              recaptcha.current.execute();
            }}
            form
            fullWidth>
            Sign up for TRAXX&#46;ID
          </TraxxButton>
        </form>
      </Card>
    </>
  );
}

export default SignUpView;
